import React from 'react';
import Banner from '../Banner/Banner';
import Search from '../Search/Search';

const Home = () => {
    return (
        <div>
            <Banner />
            <Search />
        </div>
    );
};

export default Home;